export const CHAT_COPY = {
  it: {
    open: "Pedro",
    title: "Pedro",
    subtitle: "Consulente HGW · in linea",
    placeholder: "Scrivi la tua domanda…",
    send: "Invia",
    welcome: "Ciao, sono Pedro, consulente di HGW Industry. Produciamo finestre e serramenti in alluminio e PVC e proponiamo sistemi architettonici e soluzioni outdoor: posso aiutarti a scegliere il sistema giusto o a preparare un preventivo su misura. Da dove partiamo?",
    quickReplies: [
      "Vorrei una pergola",
      "Serramenti per casa",
      "Copertura in vetro",
      "Vorrei un preventivo",
    ],
    escalateTitle: "Preferisci parlare con un operatore?",
    escalateBody: "Un membro del team ti ricontatterà. Scegli come:",
    channelEmail: "Via email",
    channelCallback: "Richiamami",
    escalateNameLabel: "Nome",
    escalateEmailLabel: "Email",
    escalatePhoneLabel: "Telefono",
    escalateNoteLabel: "Nota (opzionale)",
    escalateSubmit: "Invia richiesta",
    escalateSuccess: "Richiesta inviata. Il team ti contatterà a breve.",
    escalateBack: "← Torna alla chat",
    errorGeneric: "Errore temporaneo. Riprova tra poco.",
    powered: "AI · Le risposte possono richiedere verifica",
    typing: "Pedro sta scrivendo…",
  },
  en: {
    open: "Pedro",
    title: "Pedro",
    subtitle: "HGW Consultant · online",
    placeholder: "Ask us anything…",
    send: "Send",
    welcome: "Hi, I'm Pedro, sales consultant at HGW Industry. We manufacture aluminium and PVC windows and doors and offer architectural systems and outdoor solutions: I can help you choose the right system or prepare a tailored quote. Where shall we start?",
    quickReplies: [
      "I'd like a pergola",
      "Windows for my home",
      "Glass roof",
      "I'd like a quote",
    ],
    escalateTitle: "Prefer to talk to an operator?",
    escalateBody: "A team member will get back to you. Choose how:",
    channelEmail: "By email",
    channelCallback: "Call me back",
    escalateNameLabel: "Name",
    escalateEmailLabel: "Email",
    escalatePhoneLabel: "Phone",
    escalateNoteLabel: "Note (optional)",
    escalateSubmit: "Send request",
    escalateSuccess: "Request sent. Our team will reach out soon.",
    escalateBack: "← Back to chat",
    errorGeneric: "Temporary error. Try again shortly.",
    powered: "AI · Answers may need verification",
    typing: "Pedro is typing…",
  },
};
